import { render, staticRenderFns } from "./Kundenwahl.vue?vue&type=template&id=43a465a9&scoped=true&"
import script from "./Kundenwahl.vue?vue&type=script&lang=js&"
export * from "./Kundenwahl.vue?vue&type=script&lang=js&"
import style0 from "./Kundenwahl.vue?vue&type=style&index=0&id=43a465a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a465a9",
  null
  
)

export default component.exports